import collect from 'collect.js';
import {App} from "vue";
import dayjs, {Dayjs, isDayjs} from "dayjs";
import {times} from "@/utils";
import {getColorValue, useDebug} from "@/modules/vue/utils";
import {currency} from "@/modules/vue/i18n";
import {app as container} from "@/di";
import {ConfigRepository} from "@/modules/base/services/ConfigRepository";

export default {
  install(app: App<Element>) {
    app.config.globalProperties.collect = collect;
    app.config.globalProperties.times = times;
    app.config.globalProperties.$colorValue = getColorValue;
    app.config.globalProperties.$duration = dayjs.duration;
    app.config.globalProperties.$debug = useDebug();

    app.config.globalProperties.$moneyPerMonth = (value: number) => {
      return translator.t('money_per_month', {x: app.config.globalProperties.$money(value)});
    };
    app.config.globalProperties.$money = (value: number) => {
      return currency.n(value, 'currency');
    };

    // formats: https://day.js.org/docs/en/display/format#list-of-localized-formats
    app.config.globalProperties.$date = (date: any, format = 'L') => {
      if (!isDayjs(date)) {
        date = dayjs.utc(date);
      }

      return (date as Dayjs).format(format);
    };

    app.config.globalProperties.$config = (key: string) => {
      // @ts-ignore
      return container.get(ConfigRepository).get(key);
    };
  },
};